import React from 'react'

const FlexibleOperationsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 510 510"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                fillRule="evenodd"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#d6b748"
                        d="M287.898 117.134a140.87 140.87 0 0 1 41.3 17.117l26.837-11.906 31.62 31.62-11.906 26.837a140.87 140.87 0 0 1 17.117 41.3l27.384 10.54v44.736l-27.384 10.539a140.973 140.973 0 0 1-17.117 41.281l11.906 26.837-31.62 31.639-26.837-11.925a140.945 140.945 0 0 1-41.3 17.137l-10.54 27.364h-44.736l-10.539-27.384a140.973 140.973 0 0 1-41.281-17.117l-26.837 11.925-31.639-31.639 11.925-26.817a141.39 141.39 0 0 1-17.137-41.301L89.75 277.378v-44.736l27.364-10.54a140.945 140.945 0 0 1 17.137-41.3l-11.925-26.837 31.639-31.62 26.817 11.906a141.314 141.314 0 0 1 41.301-17.117l10.539-27.384h44.736z"
                        opacity={1}
                        data-original="#ffe177"
                        className=""
                    />
                    <path
                        fill="#a7822c"
                        d="m347.018 126.346 9.017-4.001 31.62 31.62-11.906 26.837a140.87 140.87 0 0 1 17.117 41.3l27.384 10.54v44.736l-27.384 10.539a140.973 140.973 0 0 1-17.117 41.281l11.906 26.837-31.62 31.639-9.017-4.001 27.638-27.638-11.926-26.837a141.002 141.002 0 0 0 17.118-41.281l27.383-10.539v-44.736l-27.383-10.54a140.9 140.9 0 0 0-17.118-41.3l11.926-26.837zm-197.055 0 4.002-4.001 26.817 11.906a123.158 123.158 0 0 0-5.601 3.299zm137.935-9.212a140.87 140.87 0 0 1 41.3 17.117l-7.397 3.299c-12.765-7.866-32.322-16.942-46.922-20.416l-10.54-27.384h13.019zM180.802 375.749l-26.837 11.925-4.002-4.001 25.218-11.203a131.72 131.72 0 0 0 5.621 3.279zm148.396 0a140.945 140.945 0 0 1-41.3 17.137l-10.54 27.364h-13.019l10.54-27.364c14.6-3.475 34.157-12.551 46.941-20.416z"
                        opacity={1}
                        data-original="#ffd064"
                        className=""
                    />
                    <path
                        fill="#eceff1"
                        d="M254.992 177.017c43.075 0 77.991 34.916 77.991 77.991 0 43.059-34.916 77.975-77.991 77.975-43.059 0-77.975-34.916-77.975-77.975 0-43.075 34.916-77.991 77.975-77.991z"
                        opacity={1}
                        data-original="#eceff1"
                        className=""
                    />
                    <path
                        fill="#d1d1d6"
                        d="M254.992 177.017c1.774 0 3.533.063 5.291.19-40.603 2.709-72.715 36.5-72.715 77.801 0 41.285 32.112 75.076 72.715 77.801a83.828 83.828 0 0 1-5.291.174c-43.059 0-77.975-34.916-77.975-77.975 0-43.075 34.916-77.991 77.975-77.991z"
                        opacity={1}
                        data-original="#d1d1d6"
                        className="hovered-path"
                    />
                    <path
                        fill="#466987"
                        d="m457.39 30.701-10.954 7.958a8.003 8.003 0 0 1-11.175-1.77 8.004 8.004 0 0 1 1.77-11.174l23.656-17.187a8.001 8.001 0 0 1 9.405 0l23.656 17.187a8.004 8.004 0 0 1 1.77 11.174 8.003 8.003 0 0 1-11.175 1.77l-10.953-7.958V255c0 4.415-3.585 8-8 8-4.416 0-8-3.585-8-8z"
                        opacity={1}
                        data-original="#8ac9fe"
                        className=""
                    />
                    <path
                        fill="#67676c"
                        d="m52.61 479.299 10.954-7.958a8.003 8.003 0 0 1 11.175 1.77 8.004 8.004 0 0 1-1.77 11.174l-23.656 17.187a8.001 8.001 0 0 1-9.405 0l-23.656-17.187a8.004 8.004 0 0 1-1.77-11.174 8.003 8.003 0 0 1 11.175-1.77l10.953 7.958V255c0-4.415 3.585-8 8-8 4.416 0 8 3.585 8 8z"
                        opacity={1}
                        data-original="#b1b1b5"
                        className=""
                    />
                    <path
                        fill="#3a9070"
                        d="m30.701 52.61 7.958 10.954c2.596 3.572 1.802 8.579-1.77 11.175a8.004 8.004 0 0 1-11.174-1.77L8.528 49.313a8.001 8.001 0 0 1 0-9.405l17.187-23.656c2.595-3.572 7.602-4.365 11.174-1.77s4.366 7.603 1.77 11.175L30.701 36.61H255c4.415 0 8 3.585 8 8 0 4.416-3.585 8-8 8z"
                        opacity={1}
                        data-original="#6cf5c2"
                        className=""
                    />
                    <path
                        fill="#d6b748"
                        d="M479.299 473.39H255c-4.415 0-8-3.585-8-8 0-4.416 3.585-8 8-8h224.299l-7.958-10.954c-2.596-3.572-1.802-8.579 1.77-11.175a8.004 8.004 0 0 1 11.174 1.77l17.187 23.656a8.001 8.001 0 0 1 0 9.405l-17.187 23.656c-2.595 3.572-7.602 4.365-11.174 1.77s-4.366-7.603-1.77-11.175z"
                        opacity={1}
                        data-original="#ffe177"
                        className=""
                    />
                    <path
                        fill="#706870"
                        d="M255 36.61c120.532 0 218.39 97.858 218.39 218.39S375.532 473.39 255 473.39 36.61 375.532 36.61 255 134.468 36.61 255 36.61zm0 16C143.298 52.61 52.61 143.298 52.61 255S143.298 457.39 255 457.39 457.39 366.702 457.39 255 366.702 52.61 255 52.61z"
                        opacity={1}
                        data-original="#a79ba7"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default FlexibleOperationsIcon